export const prefix = "";

export const paths = {
  login: prefix + "/",
  home: prefix + "/",
  forgetPassword: prefix + "/esqueceu_a_senha",

  profile: prefix + "/perfil",
};
